import { WindowRef } from './window-ref';

export class BrowserWindowRef extends WindowRef {
  get nativeWindow(): Window | {} {
    return window;
  }
}
